import { useRecoilValue } from 'recoil'

import { $microservices } from './selectors'

export function useMicroservices() {
  const microservices = useRecoilValue($microservices)
  return microservices
}
